module.exports = __webpack_public_path__ + "img/login-icon1.8a52aaea.png";